// 3rd party
import PropTypes from 'prop-types';
import React from 'react';

import { Alert } from 'opencare-crown';

const Error = ({ children, dataTestId, style }) => (
  <Alert
    data-testid={dataTestId}
    role="alert"
    tabIndex="0"
    type="error"
    style={style}
    message={children}
  />
);

Error.defaultProps = {
  dataTestId: 'errorBlock',
};

Error.propTypes = {
  children: PropTypes.element.isRequired,
  dataTestId: PropTypes.string,
  style: PropTypes.object,
};

export default Error;
